import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Make digital work for your business</h1>
            </header>
            <div className="content">
                <p>Leverage the power of digital technology to increase your sales and improve your bottom line.</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Get Started</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js